/* eslint-disable import/first */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { selectDefaultAddress } = Slices.addressSlice;
import formatRelative from 'date-fns/formatRelative';
import enGB from 'date-fns/locale/en-GB';
import { Button, Radio } from '@material-ui/core';
import { FaClock } from '@react-icons/all-files/fa/FaClock';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { HiChevronRight } from '@react-icons/all-files/hi/HiChevronRight';
import css from './index.module.scss';
import PopUpHeading from '../../components/PopUpHeading';

const FutureSlots = ({
  slots,
  selectedDate,
  handleslots,
  slotList,
  parseISO,
  selectedTime,
  handletime,
  format,
  proceedFuture,
  onExitMemoized,
}) => {
  const intl = useIntl();
  const defaultAddress = useSelector(selectDefaultAddress);
  // const [dateSet, setDateSet] = React.useState(0);
  // const [timeSet, setTimeSet] = React.useState(0);
  // eslint:fix
  const lastLang = intl.formatMessage({ id: 'last_date' });
  const yesterDayLang = intl.formatMessage({ id: 'yesterday_date' });
  const todayLang = intl.formatMessage({ id: 'today_date' });
  const tomorrowLang = intl.formatMessage({ id: 'tomorrow_date' });
  const formatRelativeLocale = {
    lastWeek: `'${lastLang}' eeee`,
    yesterday: `'${yesterDayLang}' | hh:mm a`,
    today: `'${todayLang}' | hh:mm a`,
    tomorrow: `'${tomorrowLang}' | hh:mm a`,
    nextWeek: 'dd MMM',
    other: 'dd MMM',
  };

  const locale = {
    ...enGB,
    formatRelative: (token) => formatRelativeLocale[token],
  };
  const currentDay = formatRelative(selectedDate, new Date(), { locale }).split('|');

  const isDuplicate = (item, index, self) => {
    return (
      self.findIndex((t) => {
        return t.value === item.value;
      }) === index
    );
  };

  const renderSlotsTime = (timeSlots) => {
    const newTimeSots = timeSlots.filter(isDuplicate);
    return newTimeSots.map((itm, idx) => {
      return (
        <FormControlLabel
          value={itm.value}
          control={<Radio />}
          checked={selectedTime === itm?.value}
          label={format(parseISO(itm.value), 'hh:mm a')}
        />
      );
    });
  };

  const titleDesc = (
    <span className={css.titleStyle}>
      <FormattedMessage
        id={`checkout_datetimedelivery_${defaultAddress.addressSubType.toLowerCase()}`}
      />
    </span>
  );

  return (
    <>
      <div className={css.futureDrawerMain}>
        <div className={css.mainFuture}>
          <PopUpHeading heading={titleDesc} onClose={onExitMemoized} />
          <div className={css.futureList}>
            {slots.length !== 0 && (
              <div className={css.dateList}>
                <FormControl>
                  <RadioGroup
                    defaultValue={slots[0].date[0].value}
                    className={css.date}
                    name="date"
                    onChange={(e, value) => {
                      let slotObj;
                      slots.forEach((slotDateObj) => {
                        slotDateObj.date.forEach((dates) => {
                          if (dates.value === +value) {
                            slotObj = { date: dates, slots: slotDateObj.slots };
                          }
                        });
                      });
                      handleslots(slotObj);
                    }}
                  >
                    {slots.map((val, i) => {
                      if (!val?.date[0]?.value) return '';
                      try {
                        return val.date.map((data) => {
                          const dataval = formatRelative(data.value, new Date(), {
                            locale,
                          }).split('|');
                          return (
                            <FormControlLabel
                              value={data?.value}
                              control={<Radio className={css.radioButton} />}
                              checked={selectedDate === data?.value}
                              label={dataval[0]}
                              key={data?.value}
                            />
                          );
                        });
                      } catch (err) {
                        console.log(err);
                      }
                    })}
                  </RadioGroup>
                </FormControl>
              </div>
            )}
            {slotList.length !== 0 && (
              <div className={css.timeSlots}>
                <FormControl>
                  <RadioGroup
                    className={css.slots}
                    defaultValue={slotList[0]?.value}
                    name="time"
                    onChange={handletime}
                  >
                    {renderSlotsTime(slotList)}
                  </RadioGroup>
                </FormControl>
              </div>
            )}
          </div>
          <div className={css.placeFuture}>
            <Button variant="contained" color="primary" size="large" onClick={proceedFuture}>
              <div className={css.dateTime}>
                <FaClock />
                <span>
                  {selectedDate ? currentDay[0].trim() : ''},{' '}
                  {intl.formatMessage({ id: 'checkout_around' })}{' '}
                  {selectedTime ? format(parseISO(selectedTime), 'hh:mm a') : ''}
                </span>
              </div>
              <div className={css.place}>
                <FormattedMessage id="checkout_proceed" defaultMessage="Proceed" />
                <HiChevronRight />
              </div>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FutureSlots;
